import React, { useEffect } from 'react';
import Form from 'screens/shared/form';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import {
  _t, objectToOptions,
} from 'utils';
import { Paper } from '@mui/material';
import { ACTIONS_TYPES } from 'redux/local';
import { AVAILABILITY_ZONE, CPU_FAMILY } from 'constant';
import { getResourceLimitsForContract } from 'utils/contract';

export default ({ serverProps = {}, dcId, id }) => {
  const {
    [ACTIONS_TYPES.DATA_CENTER.GET]: selectedDataCenter = {},
    [ACTIONS_TYPES.CONTRACT.GET_ALL]: contracts = [],
  } = useSelector((e) => e);
  const { properties = {} } = selectedDataCenter;
  const { cpuArchitecture = [] } = properties;
  const [{ maxCores = 1, maxRam = 1024 } = {}] = cpuArchitecture;

  const resourceLimits = getResourceLimitsForContract(contracts);

  let {
    coresPerServer = 1,
    ramPerServer = 1024,
  } = resourceLimits;

  coresPerServer = coresPerServer < maxCores ? coresPerServer : maxCores;
  ramPerServer = ramPerServer < maxRam ? ramPerServer : maxRam;

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'availabilityZone',
      type: 'dropdown',
      title: _t('Availability Zone'),
      options: [...objectToOptions(AVAILABILITY_ZONE)],
    },
    {
      name: 'cpuFamily',
      type: 'dropdown',
      title: _t('CPU Architecture'),
    },
    {
      name: 'cores',
      title: _t('Cores'),
      type: 'slider',
      range: [1, 100],
      showValue: true,
    },
    {
      name: 'ram',
      title: _t('RAM'),
      type: 'slider',
      range: [1, 100],
      showValue: true,
    },
  ];

  useEffect(() => {
    if (!contracts.length) {
      actions.contract.getAll();
    }
  }, [contracts]);

  useEffect(() => {
    actions.dataCenter.get({ id: dcId });
  }, [dcId]);

  const submitHandler = ({
    name, availabilityZone, cpuFamily, cores, ram,
  }) => {
    const props = {
      name, availabilityZone, cores, cpuFamily, ram: ram * 1024,
    };
    actions.server.update({ dcId, id, properties: props });
  };

  return (
    <Paper style={{ margin: 10 }}>
      <Form
        fields={fields}
        fieldsValues={serverProps}
        onSubmit={submitHandler}
        submitTitle="Update"
        isCancel={false}
        changeFields={[
          { name: 'cores', props: { range: [1, coresPerServer] } },
          { name: 'ram', props: { range: [1, (ramPerServer / 1024)] } },
          {
            name: 'cpuFamily',
            props: {
              options: cpuArchitecture.map(({ cpuFamily }) => [
                cpuFamily,
                <span>
                  <img
                    src={CPU_FAMILY[cpuFamily].logo}
                    style={{ height: 18, marginRight: 10, verticalAlign: 'middle' }}
                    alt={CPU_FAMILY[cpuFamily].name}
                  />
                  {CPU_FAMILY[cpuFamily].name}
                </span>]),
            },
          },
        ]}
      />
    </Paper>
  );
};
